export default __webpack_public_path__ + "static/media/silvia2.45b784dd.jpg";